import globalConfig from 'init/global.config'
import { hostsConfig } from 'init/config'
import ssoService from 'services/sso-service'
import submissionLoader from 'widgets/submission/submission-loader'
import submissionStore, { SellerRatingLaunchData, SubmissionPage } from 'store/submission-store'
import { TOKEN_PARAM_NAME, TurnToFlow }
  from './email-flows-common'

const SELLER_RATING_FLOW_KEYS = ['sellerrating']

/**
 * These flows are seller rating flows.  Currently, there is only one flow.
 *
 * @param flow
 * @param params
 * @param data
 */
export default {
  process(
    flow: TurnToFlow,
    params: URLSearchParams
  ): Promise<boolean> {
    return new Promise((resolve) => {
      if (SELLER_RATING_FLOW_KEYS.indexOf(flow) > -1) {
        const launchData = {
          emailToken: params.get(TOKEN_PARAM_NAME) || params.get('token')
        } as SellerRatingLaunchData
        if (params.get('starSelected')) {
          launchData.starSelected = parseInt(params.get('starSelected')) || 0
          if (launchData.starSelected < 0 || launchData.starSelected > 5) {
            launchData.starSelected = undefined
          }
        }
        const submissionPage = { page: 'seller-rating-form', props: {} } as SubmissionPage
        if (globalConfig.ssoEnabled) {
          // for soft-login
          ssoService.ssoGetLoggedInData(null, submissionPage, launchData, 'sr')
          resolve(true)
          return
        }
        submissionStore.startSellerRatingFlow(hostsConfig.siteKey, submissionPage, launchData)
        submissionLoader.load()
        resolve(true)
      } else {
        resolve(false)
      }
    })
  }
}
